
import './App.css';
import All from './All'

function App() {
  return (<>
    <div className="App">
      
    </div>
    <All/>
    </>
  );
}

export default App;
